/**
 * Shared collision envelope for streamed walls, fences and earthworks.
 * Browser Rapier physics and room authority both consume this helper so a
 * player cannot be stopped by a structure on only one side of reconciliation.
 */
export function urbanStructureCollisionDimensions(
  classCode: string,
  widthM?: number,
  heightM?: number,
): Readonly<{ widthM: number; heightM: number }> {
  const fallback = (() => {
    switch (classCode) {
      case "fence":
        return { widthM: 0.12, heightM: 1.35 };
      case "retaining_wall":
        return { widthM: 0.45, heightM: 1.5 };
      case "cliff":
        return { widthM: 0.55, heightM: 2.2 };
      case "embankment":
        return { widthM: 0.5, heightM: 0.9 };
      default:
        return { widthM: 0.3, heightM: 1.8 };
    }
  })();
  return {
    widthM: Math.min(2.5, Math.max(0.08, widthM ?? fallback.widthM)),
    heightM: Math.min(12, Math.max(0.25, heightM ?? fallback.heightM)),
  };
}
